import { render, staticRenderFns } from "./RacerProfile.vue?vue&type=template&id=369a5fa8"
import script from "./RacerProfile.vue?vue&type=script&lang=js"
export * from "./RacerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports